<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-toolbar-title class="indigo--text"
                >Seleccione sus opciones</v-toolbar-title
              >
            </v-toolbar>
            <v-container>
              <v-layout>
                <v-flex xs12 md4>
                  <v-select
                    v-model="accionValue"
                    :items="accionSelect"
                    label="Accion"
                    data-vv-name="listaAcciones"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    v-model="usuarioValue"
                    :items="usuarioSelect"
                    label="Usuario"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    v-model="procesoValue"
                    :items="procesoSelect"
                    label="Proceso"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    v-model="entidadValue"
                    :items="entidadSelect"
                    label="Entidad"
                    item-text="nombre"
                    item-value="code"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    v-model="fechaValue"
                    :items="fechaSelect"
                    label="Fecha"
                  ></v-select>
                </v-flex>
                <v-btn
                  fab
                  dark
                  color="teal"
                  title="Filtrar registros"
                  @click="filterAudit()"
                >
                  <v-icon dark>filter_list</v-icon>
                </v-btn>
                <v-btn
                  fab
                  dark
                  color="red darken-4"
                  title="Limpiar filtros"
                  @click="clear()"
                >
                  <v-icon dark>clear_all</v-icon>
                </v-btn>
              </v-layout>
            </v-container>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Registro de actividad</v-toolbar-title
              >
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
            <!-- TABLA AUDITORIA -->
            <template>
              <div v-if="loading">
                <loading></loading>
              </div>
              <div
                v-if="
                  itemsAuditoria == '' ||
                  itemsAuditoria == null ||
                  itemsAuditoria === undefined
                "
              >
                <alert-empty :alertaid="'auditoria'"></alert-empty>
              </div>
              <grid-auditoria
                :itemsAuditoria="itemsAuditoria"
                :rowsTable="rowsTable"
              ></grid-auditoria>
            </template>
            <!-- TABLA PROVEEDORES -->
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import GridAuditoria from "@/modules/configuration/auditoria/views/GridAuditoria.vue";
import { async } from "q";
import { log } from "util";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
export default {
  components: {
    GridAuditoria,
    AlertEmpty,
    Loading,
  },
  data() {
    return {
      loading: false,
      alerta: false,
      dialog: false,
      loaded: false,
      rowsTable: [20],
      itemsAuditoria: [],
      select1: null,
      accionSelect: [],
      usuarioSelect: [],
      procesoSelect: [],
      entidadSelect: [],
      fechaSelect: [],
      accionValue: null,
      usuarioValue: null,
      procesoValue: null,
      entidadValue: null,
      fechaValue: null,
      filter: false,
    };
  },
  mounted() {
    this.loadData();
    this.$store.commit("rolInContract_state", "");
  },
  created() {},
  computed: {},
  methods: {
    showAddContact() {
      this.show = true;
    },

    async loadRegistrosAuditoria() {
      let that = this;
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        proceso:
          this.procesoValue && this.procesoValue != null
            ? this.procesoValue
            : null,
        claseImpactada:
          this.entidadValue && this.entidadValue != null
            ? this.entidadValue
            : null,
        metodoAplicado:
          this.accionValue && this.accionValue != null
            ? this.accionValue
            : null,
        username:
          this.usuarioValue && this.usuarioValue != null
            ? this.usuarioValue
            : null,
        fechaCreacion:
          this.fechaValue && this.fechaValue != null ? this.fechaValue : null,
        // idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
      };

      return await axios
        .post("/auditoria/filters", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
        });
    },

    async loadData() {
      this.loading = true;
      this.itemsAuditoria = await this.loadRegistrosAuditoria();
      if (this.itemsAuditoria == undefined) {
        this.alerta = true;
        this.loading = false;
      } else {
        this.alerta = false;
        this.loading = false;
      }
      if (!this.filter) {
        this.loadAccionSelect();
        this.loadUsuarioSelect();
        this.loadProcesoSelect();
        this.loadEntidadSelect();
        this.loadFechaSelect();
      }
    },

    loadAccionSelect() {
      let acc = [];
      this.itemsAuditoria.forEach(function (p) {
        let index = acc.findIndex((x) => x.accion == p.accion);
        if (index === -1) {
          acc.push(p.accion);
        }
      });
      this.accionSelect = acc;
    },
    loadUsuarioSelect() {
      let use = [];
      this.itemsAuditoria.forEach(function (p) {
        let index = use.findIndex((x) => x.username == p.username);
        if (index === -1) {
          use.push(p.username);
        }
      });
      this.usuarioSelect = use;
    },
    loadProcesoSelect() {
      let pro = [];
      this.itemsAuditoria.forEach(function (p) {
        let index = pro.findIndex((x) => x.proceso == p.proceso);
        if (index === -1) {
          pro.push(p.proceso);
        }
      });
      this.procesoSelect = pro;
    },
    loadEntidadSelect() {
      let ent = [];
      this.itemsAuditoria.forEach(function (p) {
        let index = ent.findIndex((x) => x.claseImpactada == p.claseImpactada);
        if (index === -1) {
          ent.push(p.claseImpactada);
        }
      });
      this.entidadSelect = ent;
    },
    loadFechaSelect() {
      let fec = [];
      this.itemsAuditoria.forEach(function (p) {
        let index = fec.findIndex((x) => x.fechaCreacion == p.fechaCreacion);
        if (index === -1) {
          fec.push(p.fechaCreacion);
        }
      });
      this.fechaSelect = fec;
    },
    // Limpiar Campos
    clear() {
      this.accionValue = "";
      this.usuarioValue = "";
      this.procesoValue = "";
      this.entidadValue = "";
      this.fechaValue = "";
      this.loadData();
    },
    close() {
      window.getApp.$emit("APP_AUTH_FAILED");
    },

    filterAudit() {
      this.filter = true;
      this.loadData();
    },
  },
};
</script>
